import { getCommandRequest, linkToAppStore, copyStr } from './appCommand'
import { versionfunegt } from '../../tools/utils'
/**
 * 微信跳转壹心理app
 */
const isExit = () => document.getElementsByClassName('wxOpenInAPP') !== null

const isWechatState = () => {
  let wechat = navigator.userAgent.match(/MicroMessenger\/([\d/.]+)/i)
  if (!wechat) return false
  let judgewechat = wechat[1]
  let wechatState = false // 是否符合微信打开app的微信版本
  if (versionfunegt(judgewechat, '7.0.12')) {
    wechatState = true
  }
  return wechatState
}
export const wxOpenApp = {
  /**
   * 初始化组件
   * @param options
   * @param callback
   */
  init(options) {
    if (!isWechatState() || !isExit()) {
      if (isExit()) {
        let wxOpenInAPPBox = document.getElementsByClassName('wxOpenInAPP')
        for (let a = 0; a < wxOpenInAPPBox.length; a++) {
          wxOpenInAPPBox[a].style.display = 'none'
        }
      }

      return
    }
    if (Object.prototype.toString.call(options) !== '[object Object]') {
      options = {}
    }

    let $el = document.getElementsByClassName('wxOpenInAPP')

    for (let i = 0; i < $el.length; i++) {
      let height = $el[i].offsetHeight
      let url = $el[i].dataset.url
      let appid = $el[i].dataset.appid
        ? $el[i].dataset.appid
        : 'wx26ca27b2ef7a21d4'
      let param = { url: url ? url : window.location.href }
      let extinfo = encodeURIComponent(JSON.stringify(param))
      let $html = `
            <wx-open-launch-app
                  class="launch-btn"
                  appid="${appid ? appid : 'wx26ca27b2ef7a21d4'}"
                  extinfo="${extinfo}"
                  data-url="${url}"
                  style="position: absolute;width: 100%;height: 100%;left: 0;top: 0;opacity: 0"
                >
              <script type="text/wxtag-template">
                  <div class="btn" style="width: 100%;background: pink;height: ${height +
                    'px'} ;">App内查看</div>
              </script>
            </wx-open-launch-app>
            `
      $el[i].innerHTML = $html
    }

    let $btn = document.getElementsByClassName('launch-btn')

    const cache = {}

    const getCommand = _params => {
      const { type, title, desc, url } = _params
      if (!type || !title || !desc) {
        return Promise.resolve('')
      }
      const key = `${type}${title}${desc}${url}`

      if (cache[key]) {
        return Promise.resolve(cache[key])
      }
      return getCommandRequest(_params).then(res => {
        cache[key] = res
        return res
      })
    }
    ;(async () => {
      for (let i = 0; i < $btn.length; i++) {
        await getCommand({
          object_id: $el[i].dataset.objectId ? $el[i].dataset.objectId : '', //业务id,比如文章id
          title: $el[i].dataset.title ? $el[i].dataset.title : '', //标题
          desc: $el[i].dataset.desc ? $el[i].dataset.desc : '', //	描述
          url: $el[i].dataset.url ? $el[i].dataset.url : '', // 访问链接或协议
          type: $el[i].dataset.type ? $el[i].dataset.type : '' // 业务类型 允许值: "article", "qa", "ceping", "lesson", "meditation", "fm", "act", "summit", "identity", "group_chat"
        }).then(res => {
          $btn[i].addEventListener('launch', function() {
            console.log('launch success')
          })
          $btn[i].addEventListener('error', function(e) {
            console.log('error fail', e.detail)
            res && copyStr(res)
            linkToAppStore({
              errIosUrl: $el[i].dataset.erriosurl
                ? $el[i].dataset.erriosurl
                : '', // 失败ios跳转链接
              errAndroidUrl: $el[i].dataset.errandroidurl
                ? $el[i].dataset.errandroidurl
                : '' // 失败Android跳转链接
            })
          })
          $btn[i].addEventListener('click', function() {
            if (
              $el[i].dataset.url &&
              $el[i].dataset.url.indexOf('xinli001.com') === -1 &&
              !!$el[i].dataset.noClick !== true
            ) {
              res && copyStr(res)
              linkToAppStore({
                errIosUrl: $el[i].dataset.erriosurl
                  ? $el[i].dataset.erriosurl
                  : '', // 失败ios跳转链接
                errAndroidUrl: $el[i].dataset.errandroidurl
                  ? $el[i].dataset.errandroidurl
                  : '' // 失败Android跳转链接
              })
            }
          })
        })
      }
    })()
  }
}



// WEBPACK FOOTER //
// ./src/frontend-lib/component/wxToAPP/index.js